import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

import axios from 'axios';
import { Store } from '../../../../Store';
import { toast } from 'react-toastify';
import { getError } from '../../../../utils';
import 'react-toastify/dist/ReactToastify.css';
import '../css/login.css';

import { Form } from 'react-bootstrap';
import AnimatedInput from './AnimatedInput';

const loginFields = [
  {
    key: 'username',
    name: 'Tên tài khoản',
    type: 'text',
    icon: 'far fa-user',
    required: true,
    errorKey: 'username',
  },
  {
    key: 'password',
    name: 'Mật khẩu',
    type: 'password',
    icon: 'fas fa-key',
    required: true,
    errorKey: 'password',
  },
];

const Login = ({ onForgotPass }) => {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { rememberMe } = state;

  const location = useLocation();

  const initialForm = {
    username: '',
    password: '',
  };

  const [formData, setFormData] = useState(() => {
    if (rememberMe && typeof rememberMe === 'object') {
      return { ...initialForm, ...rememberMe };
    }
    return initialForm;
  });
  const [errors, setErrors] = useState({});
  const [isRememberMe, setIsRememberMe] = useState(false);

  const redirectHandler = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.get('/customer/auth/google/redirect');

      ctxDispatch({
        type: 'PREV-LINK',
        payload: location.pathname,
      });
      localStorage.setItem('resentLink', JSON.stringify(location.pathname));
      window.location.href = data.data;
    } catch (err) {
      toast.error(getError(err));
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.post('/login', formData);

      ctxDispatch({ type: 'USER_SIGNIN', payload: data.data });
      localStorage.setItem('userInfo', JSON.stringify(data.data));
      if (isRememberMe) {
        ctxDispatch({ type: 'SET_REMEMBERME', payload: formData });
        localStorage.setItem('rememberMe', JSON.stringify(formData));
      }
      toast.success(data.message);
    } catch (err) {
      const messages = err.response?.data?.messages;
      if (err.response?.status === 422 && messages) {
        setErrors(messages);
      } else {
        toast.error(getError(err));
      }
    }
  };

  return (
    <section>
      <Form onSubmit={submitHandler} className="modalOverideForm">
        {loginFields.map((field, idx) => (
          <div key={idx} className="mb-4">
            <AnimatedInput
              field={field}
              value={formData[field.key]}
              onChange={(e) =>
                setFormData({ ...formData, [field.key]: e.target.value })
              }
              error={errors[field.errorKey]}
            />{' '}
            {field.type === 'password' && (
              <aside className="note-pass">
                <strong style={{ color: 'var(--red)' }}>Lưu ý: </strong>Mật khẩu
                phải chứa ít nhất 8 ký tự, chữ hoa, chữ thường và số.
              </aside>
            )}
          </div>
        ))}

        <div className=" row mb-3">
          <div className="col-6">
            <Form.Check
              type="checkbox"
              id="autoSizingCheck2"
              style={{
                color: isRememberMe ? 'var(--black)' : 'var(--dark-gray)',
              }}
              label="Ghi nhớ tôi"
              checked={isRememberMe}
              onChange={() => setIsRememberMe(!isRememberMe)}
            />
          </div>
          <div className="forgot-pass col-6 d-flex justify-content-end align-items-center">
            <span onClick={onForgotPass}>Quên mật khẩu?</span>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center mb-3">
          <button type="submit" className="mb-2 btn-submit">
            Đăng nhập
          </button>
        </div>
      </Form>
    </section>
  );
};
export default Login;
